function getKey(key) {
  return `rew:${key}`;
}

export const set = (key, value) => {
  const v = value && JSON.stringify(value);
  return localStorage.setItem(getKey(key), v);
};

export const get = (key) => {
  const v = localStorage.getItem(getKey(key));
  try {
    return v && JSON.parse(v);
  } catch {
    return v;
  }
};

export const remove = (key) => localStorage.removeItem(getKey(key));
